import { motion } from "framer-motion";
import { ClipboardCheck, GitCompareArrows, Handshake, ArrowRight } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const STEPS = [
    {
        n: "01",
        icon: ClipboardCheck,
        title: "Estudio gratuito de tu perfil",
        desc: "Analizamos tu situación financiera y necesidades sin coste ni compromiso.",
    },
    {
        n: "02",
        icon: GitCompareArrows,
        title: "Comparamos y analizamos ofertas",
        desc: "Trabajamos con múltiples entidades para ofrecerte las mejores condiciones.",
    },
    {
        n: "03",
        icon: Handshake,
        title: "Negociamos por ti",
        desc: "Tu asesor personal se encarga de todo el proceso hasta la firma.",
    },
];

const fadeUp = {
    initial: { opacity: 0, y: 32 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: "-80px" },
};

export default function HowItWorks() {
    return (
        <section
            id="como-funciona"
            data-testid="how-it-works-section"
            className="bg-white py-20 lg:py-28 px-4 sm:px-6 lg:px-8"
        >
            <div className="max-w-7xl mx-auto">
                <motion.div {...fadeUp} transition={{ duration: 0.6 }} className="max-w-2xl">
                    <p className="font-mono text-xs uppercase tracking-[0.25em] text-emerald-600">
                        Cómo funciona
                    </p>
                    <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#0F172A] text-balance">
                        Solicita tu hipoteca online en 3 pasos
                    </h2>
                    <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
                        Un proceso sencillo y transparente, pensado para que no
                        te preocupes de nada.
                    </p>
                </motion.div>

                <div className="mt-14 grid md:grid-cols-3 gap-6 lg:gap-8 relative">
                    <div className="hidden md:block absolute top-16 left-[18%] right-[18%] border-t-2 border-dashed border-slate-200" />
                    {STEPS.map((s, i) => (
                        <motion.div
                            key={s.n}
                            data-testid={`how-step-${s.n}`}
                            {...fadeUp}
                            transition={{ duration: 0.6, delay: i * 0.12 }}
                            className="relative bg-[#F5F7FA] hover:bg-white border border-transparent hover:border-slate-200 rounded-3xl p-8 transition-[background-color,border-color,box-shadow,transform] duration-300 hover:-translate-y-1.5 hover:shadow-xl hover:shadow-slate-200/60"
                        >
                            <div className="flex items-center justify-between">
                                <span className="flex items-center justify-center w-14 h-14 rounded-2xl bg-[#1F3B5B] text-white">
                                    <s.icon size={24} />
                                </span>
                                <span className="font-mono text-4xl font-bold text-slate-200">
                                    {s.n}
                                </span>
                            </div>
                            <h3 className="mt-6 font-display text-xl font-semibold text-[#0F172A]">
                                {s.title}
                            </h3>
                            <p className="mt-3 text-slate-600 leading-relaxed text-[15px]">
                                {s.desc}
                            </p>
                        </motion.div>
                    ))}
                </div>

                <motion.div {...fadeUp} transition={{ duration: 0.6, delay: 0.2 }} className="mt-12">
                    <button
                        data-testid="how-it-works-cta"
                        onClick={() => scrollToId("contacto")}
                        className="group inline-flex items-center gap-2 rounded-full bg-emerald-500 hover:bg-emerald-400 text-[#0B1A2B] font-semibold px-7 py-3.5 transition-[background-color,transform] duration-200 hover:-translate-y-0.5"
                    >
                        Empieza ahora
                        <ArrowRight size={17} className="transition-transform duration-200 group-hover:translate-x-1" />
                    </button>
                </motion.div>
            </div>
        </section>
    );
}
